import * as React from 'react';

import { css } from '@compiled/react';

import AkPageHeader from '@atlaskit/page-header/page-header';
import { token } from '@atlaskit/tokens';

interface PageHeaderOwnProps {
	breadcrumbs?: React.ReactElement;
	actions?: React.ReactElement;
	children?: React.ReactNode;
	bottomBar?: React.ReactElement;
	disableTitleStyles?: boolean;
}

const ACTIONS_STYLE_HOOK = 'data-page-header-actions';

// Allows actions to wrap below title at narrow widths
const wrappingTitleRowStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	[`> div > div:has([${ACTIONS_STYLE_HOOK}])`]: {
		columnGap: token('space.400'),
		flexWrap: 'wrap',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	[`> div > div > div:has(> [${ACTIONS_STYLE_HOOK}])`]: {
		paddingInlineStart: 0,
	},
});

// Allows multiple actions to wrap over multiple rows at narrow widths
const actionsStyles = css({
	display: 'flex',
	flexWrap: 'wrap',
	rowGap: token('space.100'),
	whiteSpace: 'normal',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'> *': {
		flexWrap: 'wrap',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'> div > *': {
		flexGrow: 0,
	},
});

export const PageHeader: React.FC<PageHeaderOwnProps> = ({ actions, ...props }) => (
	<div css={wrappingTitleRowStyles}>
		<AkPageHeader
			{...props}
			actions={
				actions && (
					<div css={actionsStyles} {...{ [ACTIONS_STYLE_HOOK]: '' }}>
						{actions}
					</div>
				)
			}
		/>
	</div>
);
